<label class="switch" [ngbTooltip]="tooltip" placement="top" triggers="manual" #t1="ngbTooltip"
    (mouseleave)="toggleTooltip(t1, tooltip)" (mouseenter)="toggleTooltip(t1,tooltip)">
    <input type="checkbox" [checked]="checked" (change)="change($event)">
    <span class="slider round"></span>
</label>